import { CommitmentServer } from "@mod/commitment";

/**
 *
 * @param searchText the text to search for
 * @param text the text to be searched
 * @returns true if the text matches the search text, false otherwise
 */
export const filterText = (searchText: string, text: string | null | undefined) => {
  if (!searchText) return true;

  const searchTextLower = searchText
    .toLowerCase()
    .replace(/~/g, "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

  const searchTextArray = searchTextLower.split(" ");

  const multipleSearchArray = searchTextLower.split(",").map((text) => text.trim());

  const searchedText = text
    ?.toLowerCase()
    .replace(/~/g, "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

  // console.log("multipleSearchArray :>> ", multipleSearchArray);

  if (multipleSearchArray.length > 1) {
    return multipleSearchArray.some((multipleTextItem) =>
      multipleTextItem.split(" ").every((text) => searchedText?.includes(text))
    );
  }

  return searchedText?.includes(searchTextArray[0]);
};

/**
 *
 * @param searchText search text to filter the servers
 * @returns a function that takes a server and returns true if the server matches the search text
 * @description This function filters the servers based on the search text. It checks if the search text is present
 * in any of the server's properties.
 */
export const filterServer = (searchText: string) => (server: CommitmentServer) => {
  if (!searchText) return true;

  const searchTextLower = searchText
    .toLowerCase()
    .replace(/~/g, "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

  const searchTextArray = searchTextLower.split(" ");

  const multipleSearchArray = searchTextLower.split(",").map((text) => text.trim());

  // Remove accents and special characters from the server's properties
  // and join them into a single string
  // to make the search more flexible
  // Example: "José" => "jose", "Müller" => "muller"
  const serverInfoToSearch = [
    server.firstName,
    server.lastName,
    server.phone,
    server.groupInvitedFor,
    server.invitedFor,
    server.lastGroupName,
    server.nickname,
    server.spouseName
  ]
    .map((text) =>
      text
        ?.toLowerCase()
        .replace(/~/g, "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
    )
    .join(" ");

  if (multipleSearchArray.length > 1) {
    return multipleSearchArray.some((multipleTextItem) =>
      multipleTextItem.split(" ").every((text) => serverInfoToSearch.includes(text))
    );
  }

  // Check if the server's properties include all the search text
  return searchTextArray.every((text) => serverInfoToSearch.includes(text));
};
